export default "/images/651339ea99b9d4b2f68fefced33d5e7a.avif";